import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=7a80d138&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormMenuDownload: require('/home/runner/work/myody_front/myody_front/components/form/FormMenuDownload.vue').default})
